export const ARCHIVE_STATUS = 'archived' as const;
export const DELETE_STATUS = 'deleted' as const;
export const DEFAULT_PAGE_LIST = { page: [], total: 0 } as const;

/* sort keys */
export const NAME = 'NAME' as const;
export const KEY = 'KEY' as const;
export const LEAD = 'OWNER' as const;
export const DELETED_DATE = 'deletedDate' as const;
export const ARCHIVED_DATE = 'archivedDate' as const;
export const DELETING_IN = 'deletingIn' as const;
